<template>
    <div class="list-placeholder">
        <div class="placeholder-img" v-if="img">
            <img :src="require(`@/${img}`)" />
        </div>
        <div class="placeholder-title" v-if="title">{{ $t(title) }}</div>
        <div class="placeholder-subtitle" v-if="subtitle">
            {{ $t(subtitle) }}
            <div
                v-if="buttonText"
                class="interactive-element"
                @click="emitAction"
            >
                &nbsp;{{ buttonText }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ListPlaceholder',
    props: {
        img: String,
        title: String,
        subtitle: String,
        buttonText: String
    },
    methods: {
        emitAction() {
            this.$emit('action')
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.list-placeholder {
    width: 100%;
    height: 100%;
    padding: 2rem;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    font-family: $input-family;
}
.placeholder-img {
    width: 100%;
    height: 8rem;
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
}
.placeholder-img img {
    height: 100%;
}
.placeholder-title {
    font-size: 2rem;
}
.placeholder-subtitle {
    font-size: 1.5rem;
    color: $input-placeholder;
    display: flex;
    margin-top: 0.5rem;
}
.interactive-element {
    cursor: pointer;
    color: $accent-blue;
    transition: $ease;

    &:hover {
        transform: translateY(0.1rem);
    }
}
</style>
